import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import { ReactElement } from 'react';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

type PersonCardTemplateTabsProps = {
    personInfoTabElement: JSX.Element;
    personCotnactTabElement: JSX.Element;
};

export default function PersonCardTemplateTabs(props: PersonCardTemplateTabsProps): ReactElement {
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%', height: 400 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab icon={<PermIdentityIcon style={{ fontSize: 16 }} />} {...a11yProps(0)} />
                    <Tab icon={<ContactPageIcon style={{ fontSize: 16 }} />} {...a11yProps(1)} />
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                {props.personInfoTabElement}
            </TabPanel>
            <TabPanel value={value} index={1}>
                {props.personCotnactTabElement}
            </TabPanel>
        </Box>
    );
}
